module.exports = __webpack_public_path__ + "media/images/older_interview_woman_image-4da211a7c7c69b9b855b2a7d17ab934e.png";